import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';
import remarkGfm from 'remark-gfm';
import Label from 'layout/atoms/Label';
import PageGuideCard from 'molecules/PageGuideCard/PageGuideCard';
const markdownComponents = {
    a: ({ href, children }) => (href === null || href === void 0 ? void 0 : href.startsWith('/')) ? (React.createElement(Link, { to: href }, children)) : (React.createElement("a", { href: href, target: "_blank", rel: "noopener noreferrer" }, children)),
};
function PageGuideTemplate({ title, body, onDismissAll, onDone }) {
    const { t } = useTranslation('pageGuides');
    return (React.createElement(PageGuideCard, { buttons: [
            { label: t('DISMISS_ALL'), onClick: onDismissAll, color: 'secondary' },
            { label: t('DONE'), onClick: onDone, color: 'primary' },
        ] },
        React.createElement(Label, { color: "normal", size: "s" }, title),
        React.createElement(ReactMarkdown, { remarkPlugins: [remarkGfm], components: markdownComponents }, body)));
}
export default PageGuideTemplate;
